import { Grid, Typography } from "@material-ui/core";
import millify from "millify";
import NumberFormat from "react-number-format";
import { useSelector } from "react-redux";

const Financials = (props) => {
  const values = props.values;
  const isDesktopOrLaptop = useSelector((state) => state.screenSize.value);
  const marketingCap = values?.MarketCapitalization?.toString().split(".");
  const marketingCapInt = marketingCap ? marketingCap[0]?.length : 0;
  const t = props.t;

  return (
    <Grid container style={{ justifyContent: "center" }}>
      <Grid
        item
        xs={isDesktopOrLaptop ? 6 : 12}
        style={{
          paddingRight: "5px",
        }}
      >
        <Grid
          container
          style={{
            backgroundColor: "#f8faff",
            width: isDesktopOrLaptop ? "80%" : "100%",
            height: "38px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Grid
            item
            xs={isDesktopOrLaptop ? 6 : 6}
            style={{ display: "flex", justifyContent: "flex-start" }}
          >
            <Typography
              style={{
                fontFamily: "Overpass",
                fontStyle: "normal",
                fontWeight: "normal",
                fontSize: isDesktopOrLaptop ? "16px" : "14px",
                lineHeight: isDesktopOrLaptop ? 1.31 : 1.5,
                color: "#808080",
              }}
            >
              {t("market_capitalization")}
            </Typography>
          </Grid>
          <Grid
            item
            xs={isDesktopOrLaptop ? 6 : 6}
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Typography
              style={{
                fontFamily: "Overpass",
                fontStyle: "normal",
                fontWeight: "normal",
                fontSize: isDesktopOrLaptop ? "16px" : "14px",
                lineHeight: isDesktopOrLaptop ? 1.31 : 1.5,
                color: "#808080",
              }}
            >
              {values?.MarketCapitalization === -99999.99 ? (
                "N/A"
              ) : marketingCapInt < 7 ? (
                millify(
                  values?.MarketCapitalization
                    ? values?.MarketCapitalization
                    : 0,
                  {
                    units: [`M ${props.cur}`, `B ${props.cur}`],
                    space: true,
                    precision: 2,
                  }
                )
              ) : (
                <NumberFormat
                  value={
                    values?.MarketCapitalization
                      ? values?.MarketCapitalization / 1000
                      : 0 / 1000
                  }
                  thousandSeparator={"'"}
                  displayType="text"
                  suffix={` B ${props.cur}`}
                  decimalScale={2}
                />
              )}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          style={{
            width: isDesktopOrLaptop ? "80%" : "100%",
            height: "38px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Grid
            item
            xs={isDesktopOrLaptop ? 6 : 8}
            style={{ display: "flex", justifyContent: "flex-start" }}
          >
            <Typography
              style={{
                fontFamily: "Overpass",
                fontStyle: "normal",
                fontWeight: "normal",
                fontSize: isDesktopOrLaptop ? "16px" : "14px",
                lineHeight: isDesktopOrLaptop ? 1.31 : 1.5,
                color: "#808080",
              }}
            >
              {t("52_weeks_high")}
            </Typography>
          </Grid>
          <Grid
            item
            xs={isDesktopOrLaptop ? 6 : 4}
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Typography
              style={{
                fontFamily: "Overpass",
                fontStyle: "normal",
                fontWeight: "normal",
                fontSize: isDesktopOrLaptop ? "16px" : "14px",
                lineHeight: isDesktopOrLaptop ? 1.31 : 1.5,
                color: "#808080",
              }}
            >
              {values?.WeekHigh52 === -99999.99
                ? "N/A"
                : `${values?.WeekHigh52?.toFixed(2)} ${props.cur}`}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          style={{
            backgroundColor: "#f8faff",
            width: isDesktopOrLaptop ? "80%" : "100%",
            height: "38px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Grid
            item
            xs={isDesktopOrLaptop ? 6 : 8}
            style={{ display: "flex", justifyContent: "flex-start" }}
          >
            <Typography
              style={{
                fontFamily: "Overpass",
                fontStyle: "normal",
                fontWeight: "normal",
                fontSize: isDesktopOrLaptop ? "16px" : "14px",
                lineHeight: isDesktopOrLaptop ? 1.31 : 1.5,
                color: "#808080",
              }}
            >
              {t("52_weeks_low")}
            </Typography>
          </Grid>
          <Grid
            item
            xs={isDesktopOrLaptop ? 6 : 4}
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Typography
              style={{
                fontFamily: "Overpass",
                fontStyle: "normal",
                fontWeight: "normal",
                fontSize: isDesktopOrLaptop ? "16px" : "14px",
                lineHeight: isDesktopOrLaptop ? 1.31 : 1.5,
                color: "#808080",
              }}
            >
              {values?.WeekLow52 === -99999.99
                ? "N/A"
                : `${values?.WeekLow52?.toFixed(2)} ${props.cur}`}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          style={{
            width: isDesktopOrLaptop ? "80%" : "100%",
            height: "38px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Grid
            item
            xs={isDesktopOrLaptop ? 6 : 8}
            style={{ display: "flex", justifyContent: "flex-start" }}
          >
            <Typography
              style={{
                fontFamily: "Overpass",
                fontStyle: "normal",
                fontWeight: "normal",
                fontSize: isDesktopOrLaptop ? "16px" : "14px",
                lineHeight: isDesktopOrLaptop ? 1.31 : 1.5,
                color: "#808080",
              }}
            >
              {t("dividend_yield")}
            </Typography>
          </Grid>
          <Grid
            item
            xs={isDesktopOrLaptop ? 6 : 4}
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Typography
              style={{
                fontFamily: "Overpass",
                fontStyle: "normal",
                fontWeight: "normal",
                fontSize: isDesktopOrLaptop ? "16px" : "14px",
                lineHeight: isDesktopOrLaptop ? 1.31 : 1.5,
                color: "#808080",
              }}
            >
              {values?.DividendYield === -99999.99
                ? "N/A"
                : `${values?.DividendYield?.toFixed(2)} %`}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          style={{
            backgroundColor: "#f8faff",
            width: isDesktopOrLaptop ? "80%" : "100%",
            height: "38px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Grid
            item
            xs={isDesktopOrLaptop ? 9 : 9}
            style={{ display: "flex", justifyContent: "flex-start" }}
          >
            <Typography
              style={{
                fontFamily: "Overpass",
                fontStyle: "normal",
                fontWeight: "normal",
                fontSize: isDesktopOrLaptop ? "16px" : "14px",
                lineHeight: isDesktopOrLaptop ? 1.31 : 1.5,
                color: "#808080",
              }}
            >
              {t("dividend_rate")}
            </Typography>
          </Grid>
          <Grid
            item
            xs={isDesktopOrLaptop ? 3 : 3}
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Typography
              style={{
                fontFamily: "Overpass",
                fontStyle: "normal",
                fontWeight: "normal",
                fontSize: isDesktopOrLaptop ? "16px" : "14px",
                lineHeight: isDesktopOrLaptop ? 1.31 : 1.5,
                color: "#808080",
              }}
            >
              {values?.DividendPerShareAnnual === -99999.99
                ? "N/A"
                : `${values?.DividendPerShareAnnual?.toFixed(2)} ${props.cur}`}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          style={{
            width: isDesktopOrLaptop ? "80%" : "100%",
            height: "38px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Grid
            item
            xs={isDesktopOrLaptop ? 9 : 9}
            style={{ display: "flex", justifyContent: "flex-start" }}
          >
            <Typography
              style={{
                fontFamily: "Overpass",
                fontStyle: "normal",
                fontWeight: "normal",
                fontSize: isDesktopOrLaptop ? "16px" : "14px",
                lineHeight: isDesktopOrLaptop ? 1.31 : 1.5,
                color: "#808080",
              }}
            >
              {t("P/E_ratio")}
            </Typography>
          </Grid>
          <Grid
            item
            xs={isDesktopOrLaptop ? 3 : 3}
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Typography
              style={{
                fontFamily: "Overpass",
                fontStyle: "normal",
                fontWeight: "normal",
                fontSize: isDesktopOrLaptop ? "16px" : "14px",
                lineHeight: isDesktopOrLaptop ? 1.31 : 1.5,
                color: "#808080",
              }}
            >
              {values?.PEexclExtraItemsTTM === -99999.99
                ? "N/A"
                : `${values?.PEexclExtraItemsTTM?.toFixed(2)}`}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid
        item
        xs={isDesktopOrLaptop ? 6 : 12}
        style={{
          paddingLeft: isDesktopOrLaptop ? "5px" : "0px",
        }}
      >
        <Grid
          container
          style={{
            backgroundColor: "#f8faff",
            width: isDesktopOrLaptop ? "80%" : "100%",
            height: "38px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Grid
            item
            xs={isDesktopOrLaptop ? 6 : 8}
            style={{ display: "flex", justifyContent: "flex-start" }}
          >
            <Typography
              style={{
                fontFamily: "Overpass",
                fontStyle: "normal",
                fontWeight: "normal",
                fontSize: isDesktopOrLaptop ? "16px" : "14px",
                lineHeight: isDesktopOrLaptop ? 1.31 : 1.5,
                color: "#808080",
              }}
            >
              {t("Net_debt")}
            </Typography>
          </Grid>
          <Grid
            item
            xs={isDesktopOrLaptop ? 6 : 4}
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Typography
              style={{
                fontFamily: "Overpass",
                fontStyle: "normal",
                fontWeight: "normal",
                fontSize: isDesktopOrLaptop ? "16px" : "14px",
                lineHeight: isDesktopOrLaptop ? 1.31 : 1.5,
                color: "#808080",
              }}
            >
              {values?.NetDebt === -99999.99
                ? "N/A"
                : `${values?.NetDebt?.toFixed(2)} ${props.cur}`}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          style={{
            width: isDesktopOrLaptop ? "80%" : "100%",
            height: "38px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Grid
            item
            xs={isDesktopOrLaptop ? 7 : 8}
            style={{ display: "flex", justifyContent: "flex-start" }}
          >
            <Typography
              style={{
                fontFamily: "Overpass",
                fontStyle: "normal",
                fontWeight: "normal",
                fontSize: isDesktopOrLaptop ? "16px" : "14px",
                lineHeight: isDesktopOrLaptop ? 1.31 : 1.5,
                color: "#808080",
              }}
            >
              {t("gross_margin")}
            </Typography>
          </Grid>
          <Grid
            item
            xs={isDesktopOrLaptop ? 5 : 4}
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Typography
              style={{
                fontFamily: "Overpass",
                fontStyle: "normal",
                fontWeight: "normal",
                fontSize: isDesktopOrLaptop ? "16px" : "14px",
                lineHeight: isDesktopOrLaptop ? 1.31 : 1.5,
                color: "#808080",
              }}
            >
              {values?.GrossMarginAnnuial === -99999.99
                ? "N/A"
                : `${values?.GrossMarginAnnuial?.toFixed(2)} %`}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          style={{
            backgroundColor: "#f8faff",
            width: isDesktopOrLaptop ? "80%" : "100%",
            height: "38px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Grid
            item
            xs={isDesktopOrLaptop ? 8 : 8}
            style={{ display: "flex", justifyContent: "flex-start" }}
          >
            <Typography
              style={{
                fontFamily: "Overpass",
                fontStyle: "normal",
                fontWeight: "normal",
                fontSize: isDesktopOrLaptop ? "16px" : "14px",
                lineHeight: isDesktopOrLaptop ? 1.31 : 1.5,
                color: "#808080",
              }}
            >
              {t("net_profit_margin")}
            </Typography>
          </Grid>
          <Grid
            item
            xs={isDesktopOrLaptop ? 4 : 4}
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Typography
              style={{
                fontFamily: "Overpass",
                fontStyle: "normal",
                fontWeight: "normal",
                fontSize: isDesktopOrLaptop ? "16px" : "14px",
                lineHeight: isDesktopOrLaptop ? 1.31 : 1.5,
                color: "#808080",
              }}
            >
              {values?.NetprofitmarginAnnual === -99999.99
                ? "N/A"
                : `${values?.NetprofitmarginAnnual?.toFixed(2)} %`}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          style={{
            width: isDesktopOrLaptop ? "80%" : "100%",
            height: "38px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Grid
            item
            xs={isDesktopOrLaptop ? 6 : 7}
            style={{ display: "flex", justifyContent: "flex-start" }}
          >
            <Typography
              style={{
                fontFamily: "Overpass",
                fontStyle: "normal",
                fontWeight: "normal",
                fontSize: isDesktopOrLaptop ? "16px" : "14px",
                lineHeight: isDesktopOrLaptop ? 1.31 : 1.5,
                color: "#808080",
              }}
            >
              {t("revenues")}
            </Typography>
          </Grid>
          <Grid
            item
            xs={isDesktopOrLaptop ? 6 : 5}
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Typography
              style={{
                fontFamily: "Overpass",
                fontStyle: "normal",
                fontWeight: "normal",
                fontSize: isDesktopOrLaptop ? "16px" : "14px",
                lineHeight: isDesktopOrLaptop ? 1.31 : 1.5,
                color: "#808080",
              }}
            >
              {values?.RevenuesAnnual === -99999.99
                ? "N/A"
                : `${values?.RevenuesAnnual?.toFixed(2)} ${props.cur}`}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          style={{
            backgroundColor: "#f8faff",
            width: isDesktopOrLaptop ? "80%" : "100%",
            height: "38px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Grid
            item
            xs={isDesktopOrLaptop ? 6 : 8}
            style={{ display: "flex", justifyContent: "flex-start" }}
          >
            <Typography
              style={{
                fontFamily: "Overpass",
                fontStyle: "normal",
                fontWeight: "normal",
                fontSize: isDesktopOrLaptop ? "16px" : "14px",
                lineHeight: isDesktopOrLaptop ? 1.31 : 1.5,
                color: "#808080",
              }}
            >
              {t("return_on_equity")}
            </Typography>
          </Grid>
          <Grid
            item
            xs={isDesktopOrLaptop ? 6 : 4}
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Typography
              style={{
                fontFamily: "Overpass",
                fontStyle: "normal",
                fontWeight: "normal",
                fontSize: isDesktopOrLaptop ? "16px" : "14px",
                lineHeight: isDesktopOrLaptop ? 1.31 : 1.5,
                color: "#808080",
              }}
            >
              {values?.ReturnonEquityTTM === -99999.99
                ? "N/A"
                : `${values?.ReturnonEquityTTM?.toFixed(2)} %`}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Financials;
